
import XTable from 'vux/src/components/x-table/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

import axios from "axios";
import qs from "qs";
import conf from "./../../config/base.js";

export default {
components: {
XTable,
XInput,
XButton
},
data() {
return {
accessToken: "",
accessToken2: "",
classifyList: [],
goodsList: [],
selected: 99891188
};
},
created() {},
activated() {
var $self = this;
$self.code = $self.$route.query.code;
$self.getAccessToken();
},
/**计算属性 将状态表中的数据 映射出来*/
computed: {},
/**初始化的时候调用  类似于 ready */
mounted() {
var $self = this;

},
methods: {

importGoods() {
console.log("import goods.");
},
getAccessToken() {
let $self = this;
const params = {
method: "getWeimobToken",
code: $self.code
};
$self.scanNotify(params).then(res => {
$self.$clog(res.data);
if (res.data.status == 1) {
$self.accessToken = res.data.token;
$self.getClassify();
}
});
},
getClassify() {
let $self = this;
const params = {
method: "getWeimobClassify",
token: $self.accessToken
};
$self.scanNotify(params).then(res => {
$self.$clog(res.data);
$self.classifyList = res.data.goodsClassifyList;
});
},
getGoodsList() {
let $self = this;
const params = {
method: "getWeimobGoodsList",
token: $self.accessToken,
pageNum: 1,
pageSize: 10,
goodsClassifyId: $self.selected
};
$self.scanNotify(params).then(res => {
$self.$clog(res.data);
$self.goodsList = res.data.pageList;
});
},
chooseClassify() {
let $self = this;
console.log("you selected " + $self.selected);
$self.getGoodsList();
},
scanNotify(object) {
let $self = this;
var params = {
dataMap: JSON.stringify(object)
};
return $self
.getHttp()
.post(
"/issp/ApiService?method=xforceplus.toc.scanNotify&APIKey=" +
conf.api.api_key,
params
);
},
getHttp() {
/**
* http配置
*/
var instance = axios.create({
baseURL: conf.api.SALES_API_ROOT,
timeout: 60000,

headers: {

"Content-Type": "application/x-www-form-urlencoded; charset=utf-8;"



}
});


instance.interceptors.request.use(
config => {

if (config.method === "post") {
config.data = qs.stringify(config.data);
}




return config;
},
error => {
return Promise.reject(error);
}
);


instance.interceptors.response.use(
response => {

return response;
},
error => {

return Promise.reject(error);
}
);
return instance;
}
}
};
